<div class="location-lottie">
    <ng-lottie width="100%" [options]="options"></ng-lottie>
    <div class="detectingText">
      <h1>{{lottieTranslation['title']}}</h1>
      <p>{{lottieTranslation['content']}}</p>
    </div>
</div>
